var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "summary view" }, [
    _vm.isE2EFlow
      ? _c(
          "div",
          { staticClass: "view_top" },
          [
            _c("ma-navbar-stepper", {
              attrs: { numberOfStep: 4, textOfStep: _vm.$t("stepper.step4") },
            }),
          ],
          1
        )
      : _vm._e(),
    Object.values(_vm.damages).length > 0
      ? _c("div", { staticClass: "view_content" }, [
          _c("div", { staticClass: "view_content_markdown" }, [
            _c("h1", { staticClass: "summary_title" }, [
              _vm._v(_vm._s(_vm.$t("summary.title"))),
            ]),
            _vm.isInmobilier && _vm.damages.inmobilier.compensation_base !== 0
              ? _c("div", { staticClass: "summary_container" }, [
                  _c("p", { staticClass: "mg mg--b-4 mg--t-4 summary_types" }, [
                    _vm._v(_vm._s(_vm.$t("summary.immobilier.title"))),
                  ]),
                  _vm.getFlowState === "REN_RESUME"
                    ? _c("p", { staticClass: "mg mg--b-4" }, [
                        _vm._v(
                          _vm._s(_vm.$t("summary.immobilier.ren.solution"))
                        ),
                      ])
                    : _vm._e(),
                  _vm.getFlowState === "GAG_RESUME"
                    ? _c("p", { staticClass: "mg mg--b-4" }, [
                        _vm._v(
                          _vm._s(_vm.$t("summary.immobilier.gag.solution"))
                        ),
                      ])
                    : _vm._e(),
                  _vm.getFlowState === "BILLMA_RESUME"
                    ? _c("p", { staticClass: "mg mg--b-4" }, [
                        _vm._v(_vm._s(_vm.$t("summary.billma.solution"))),
                      ])
                    : _vm._e(),
                  _vm.isRen && !_vm.isRenCalendarFailure
                    ? _c("div", { staticClass: "compensation-date" }, [
                        _c("p", { staticClass: "gray mg mg--t-3" }, [
                          _vm._v(
                            _vm._s(_vm.$t("summary.immobilier.ren.text1"))
                          ),
                        ]),
                        _c(
                          "div",
                          { staticClass: "compensation-container" },
                          [
                            _c("svgicon", {
                              staticClass: "icon",
                              attrs: {
                                name: "calendar",
                                color: "#5F646C",
                                height: "15",
                                width: "auto",
                              },
                            }),
                            _c("p", { staticClass: "gray" }, [
                              _vm._v(_vm._s(_vm.renInfo.date_ren)),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "compensation-container" },
                          [
                            _c("svgicon", {
                              staticClass: "icon",
                              attrs: {
                                name: "house",
                                color: "#5F646C",
                                height: "15",
                                width: "auto",
                              },
                            }),
                            _c("p", { staticClass: "gray" }, [
                              _vm._v(_vm._s(_vm.renInfo.address)),
                            ]),
                          ],
                          1
                        ),
                        _c("p", { staticClass: "gray mg mg--b-2" }, [
                          _vm._v(
                            _vm._s(_vm.$t("summary.immobilier.ren.text2"))
                          ),
                        ]),
                        _c("div", { staticClass: "phone-container" }, [
                          _c(
                            "a",
                            { attrs: { href: "tel:0140093839" } },
                            [
                              _c("svgicon", {
                                attrs: {
                                  name: "phone",
                                  color: "#005BA5",
                                  width: "18",
                                  height: "18",
                                },
                              }),
                              _c("p", { staticClass: "phone-number" }, [
                                _vm._v("01 40 09 38 39"),
                              ]),
                              _c("p", { staticClass: "gray" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("summary.immobilier.ren.phoneText")
                                  )
                                ),
                              ]),
                            ],
                            1
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm.isBillma && !_vm.isBillMaDocumentFailure
                    ? _c("div", { staticClass: "billma" }, [
                        _c("p", { staticClass: "gray mg mg--t-3 pre-line" }, [
                          _vm._v(_vm._s(_vm.$t("summary.billma.text1"))),
                        ]),
                        _c("p", { staticClass: "gray mg mg--t-3 pre-line" }, [
                          _vm._v(_vm._s(_vm.$t("summary.billma.text2"))),
                        ]),
                        _c("p", { staticClass: "gray mg mg--t-3 pre-line" }, [
                          _vm._v(_vm._s(_vm.$t("summary.billma.text3"))),
                        ]),
                      ])
                    : _vm._e(),
                  _vm.isRenCalendarFailure
                    ? _c("div", [
                        _c("p", { staticClass: "mg mg--b-4" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("summary.immobilier.noAppointment.p1")
                            )
                          ),
                        ]),
                        _c("p", { staticClass: "mg mg--b-4" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("summary.immobilier.noAppointment.p2")
                            )
                          ),
                        ]),
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("summary.immobilier.noAppointment.p3")
                            )
                          ),
                        ]),
                      ])
                    : _vm.isBillMaDocumentFailure
                    ? _c("div", [
                        _c("p", { staticClass: "mg mg--b-4" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("summary.immobilier.billmaFailure.p1")
                            )
                          ),
                        ]),
                        _c("p", { staticClass: "mg mg--b-4" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("summary.immobilier.billmaFailure.p2")
                            )
                          ),
                        ]),
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("summary.immobilier.billmaFailure.p3")
                            )
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _c("p"),
                  _vm.getFlowState === "GAG_RESUME"
                    ? _c("div", { staticClass: "compensation-base" }, [
                        _c(
                          "div",
                          { staticClass: "summary_content gag-resume" },
                          [
                            _c("span", { staticClass: "blueDark" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("summary.immobilier.gag.compensation")
                                )
                              ),
                            ]),
                            _c("div", { staticClass: "mount" }, [
                              _c("p", { staticClass: "gray mg mg--t-3" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "summary.immobilier.gag.indemnisation"
                                    )
                                  )
                                ),
                              ]),
                              _c("p", { staticClass: "gray mg mg--t-3" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.replaceDots(
                                      _vm.damages.inmobilier.compensation_base
                                    )
                                  ) + "€"
                                ),
                              ]),
                            ]),
                            _vm.isGag
                              ? _c(
                                  "ma-accordion",
                                  {
                                    ref: "accordion",
                                    staticClass: "summary_accordion",
                                  },
                                  [
                                    _c("template", { slot: "accordionTop" }, [
                                      _c(
                                        "p",
                                        { staticClass: "text-small blueDark" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "summary.immobilier.gag.details"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _c(
                                      "template",
                                      { slot: "accordionBottom" },
                                      [
                                        _vm.damages.inmobilier
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "summary-accordion",
                                              },
                                              [
                                                _vm.damagesImmobilier
                                                  ? _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "text-medium gray mg mg--b-3",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "summary.immobilier.gag.dommages"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "compensation-base",
                                                  },
                                                  [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "text-small gray mg mg--t-3",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "summary.immobilier.gag.indemnisation"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "text-small gray mg mg--t-3",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.replaceDots(
                                                              _vm.damages
                                                                .inmobilier
                                                                .compensation_base
                                                            )
                                                          ) + "€"
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "content-material mg mg--t-4",
                                                  },
                                                  [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "text-small",
                                                        on: {
                                                          click:
                                                            _vm.handleOpenDescriptionModal,
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "blueDark mg mg--r-1",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "summary.immobilier.gag.calcule"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _c("svgicon", {
                                                          attrs: {
                                                            name: "question",
                                                            color: "#005BA5",
                                                            width: "12",
                                                            height: "12",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "ma-modal",
                                                      {
                                                        ref: "modalDescription",
                                                        staticClass:
                                                          "modal-confirmation",
                                                        attrs: {
                                                          type: "small",
                                                        },
                                                        on: {
                                                          "modal:close":
                                                            _vm.handleCloseDescriptionModal,
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "template",
                                                          {
                                                            slot: "modalContent",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "modal__main view",
                                                              },
                                                              [
                                                                _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "headline-medium gray mg mg--b-5",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "damageValidation.modal.title"
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "modal-subtitle headline-medium text-medium gray mg mg--b-5",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "damageValidation.modal.subtitle"
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "button",
                                                                  {
                                                                    staticClass:
                                                                      "btn mainBlue damage-validation_button",
                                                                    on: {
                                                                      click:
                                                                        _vm.handleCloseDescriptionModal,
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "p",
                                                                      {
                                                                        staticClass:
                                                                          "text-medium",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "summary.immobilier.gag.modal.confirm"
                                                                            )
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      2
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c("p"),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ],
                                  2
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm.isGag
                    ? _c(
                        "p",
                        { staticClass: "mg mg--t-2 summary_description" },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("summary.immobilier.description"))
                          ),
                        ]
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm.isMobilier || _vm.damages.mobilier
              ? _c(
                  "div",
                  { staticClass: "summary_container" },
                  [
                    _c(
                      "p",
                      { staticClass: "mg mg--t-4 mg--b-4 summary_types" },
                      [_vm._v(_vm._s(_vm.$t("summary.mobilier.title")))]
                    ),
                    _c("p", { staticClass: "mg mg--t-4 mg--b-4" }, [
                      _vm._v(_vm._s(_vm.$t("summary.mobilier.solution"))),
                    ]),
                    _c("div", { staticClass: "summary_content" }, [
                      _c("div", { staticClass: "summary_compensation" }, [
                        _c("span", { staticClass: "blueDark" }, [
                          _vm._v(_vm._s(_vm.$t("summary.mobilier.subtitle"))),
                        ]),
                      ]),
                      _c("div", { staticClass: "compensation-base" }, [
                        _c("p", { staticClass: "gray mg mg--t-3" }, [
                          _vm._v(
                            _vm._s(_vm.$t("summary.mobilier.indemnisation"))
                          ),
                        ]),
                        _c("p", { staticClass: "gray mg mg--t-3" }, [
                          _vm._v(
                            _vm._s(
                              _vm.replaceDots(
                                _vm.damages.mobilier.compensation_base
                              )
                            ) + "€"
                          ),
                        ]),
                      ]),
                    ]),
                    _c(
                      "ma-accordion",
                      { ref: "accordion", staticClass: "summary_accordion" },
                      [
                        _c("template", { slot: "accordionTop" }, [
                          _c("p", { staticClass: "text-small blueDark" }, [
                            _vm._v(_vm._s(_vm.$t("summary.mobilier.details"))),
                          ]),
                        ]),
                        _c("template", { slot: "accordionBottom" }, [
                          _c(
                            "div",
                            { staticClass: "summary-accordion" },
                            [
                              _vm._l(_vm.mobilierDamages, function (damage) {
                                return _c("ul", { staticClass: "mg mg--t-2" }, [
                                  damage.brand !== undefined
                                    ? _c("li", { staticClass: "mg mg--b-2" }, [
                                        _c("p", { staticClass: "mg mg--b-2" }, [
                                          _vm._v(_vm._s(damage.product)),
                                        ]),
                                        _c("p", { staticClass: "text-small" }, [
                                          _vm._v(
                                            _vm._s(damage.brand) +
                                              " " +
                                              _vm._s(damage.reference)
                                          ),
                                        ]),
                                      ])
                                    : _c("li", { staticClass: "mg mg--b-2" }, [
                                        _c("p", { staticClass: "mg mg--b-2" }, [
                                          _vm._v(_vm._s(damage.product)),
                                        ]),
                                        _c("p", { staticClass: "text-small" }, [
                                          _vm._v(_vm._s(damage.category)),
                                        ]),
                                      ]),
                                ])
                              }),
                              _vm.damages.mobilier
                                ? _c(
                                    "div",
                                    { staticClass: "compensation-base" },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "text-small gray mg mg--t-3",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("summary.mobilier.total")
                                            )
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "text-small gray mg mg--t-3",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.replaceDots(
                                                _vm.damages.mobilier
                                                  .compensation_base
                                              )
                                            ) + "€"
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]),
                      ],
                      2
                    ),
                    _c("p", { staticClass: "mg mg--t-2 summary_description" }, [
                      _vm._v(_vm._s(_vm.$t("summary.mobilier.description"))),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
            _vm.isFrais
              ? _c("div", [
                  _c("p", { staticClass: "mg mg--t-4 mg--b-2 summary_types" }, [
                    _vm._v(_vm._s(_vm.$t("summary.frais.title"))),
                  ]),
                  _c("p", { staticClass: "mg mg--t-4 mg--b-4" }, [
                    _vm._v(_vm._s(_vm.$t("summary.frais.solution"))),
                  ]),
                  _c("div", { staticClass: "summary_content" }, [
                    _c("div", { staticClass: "summary_frais" }, [
                      _c("div", { staticClass: "summary_frais_literals" }, [
                        _c(
                          "p",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.fraisDamagesObj.leak_search > 0,
                                expression: "fraisDamagesObj.leak_search > 0",
                              },
                            ],
                            staticClass: "mg mg--t-2",
                          },
                          [_vm._v(_vm._s(_vm.$t("summary.frais.recherche")))]
                        ),
                        _c(
                          "p",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.fraisDamagesObj.moving_furniture > 0,
                                expression:
                                  "fraisDamagesObj.moving_furniture > 0",
                              },
                            ],
                            staticClass: "mg mg--t-2",
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("summary.frais.deplacement"))
                            ),
                          ]
                        ),
                        _c(
                          "p",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.fraisDamagesObj.secured > 0,
                                expression: "fraisDamagesObj.secured > 0",
                              },
                            ],
                            staticClass: "mg mg--t-2",
                          },
                          [_vm._v(_vm._s(_vm.$t("summary.frais.mise")))]
                        ),
                        _c(
                          "p",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.fraisDamagesObj.temporary_repair > 0,
                                expression:
                                  "fraisDamagesObj.temporary_repair > 0",
                              },
                            ],
                            staticClass: "mg mg--t-2",
                          },
                          [_vm._v(_vm._s(_vm.$t("summary.frais.provisorie")))]
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "summary_frais_amount" },
                        _vm._l(_vm.fraisDamages, function (frais) {
                          return _c("li", [
                            frais !== 0
                              ? _c("p", { staticClass: "mg mg--t-2" }, [
                                  _vm._v(_vm._s(frais) + "€"),
                                ])
                              : _vm._e(),
                          ])
                        }),
                        0
                      ),
                    ]),
                  ]),
                  _c("p", { staticClass: "mg mg--t-2 summary_description" }, [
                    _vm._v(_vm._s(_vm.$t("summary.frais.description"))),
                  ]),
                ])
              : _vm._e(),
            _c("div", { staticClass: "summary_container" }, [
              _c("p", { staticClass: "mg mg--t-8 mg--b-2 summary_types" }, [
                _vm._v("Franchise"),
              ]),
              _c("div", { staticClass: "summary_content" }, [
                _c("div", { staticClass: "summary_frais" }, [
                  _c("div", { staticClass: "summary_frais_literals" }, [
                    _c("p", { staticClass: "mg mg--t-2 mg--b-2" }, [
                      _vm._v(_vm._s(_vm.franchiseBlueContainerText)),
                    ]),
                  ]),
                  _vm.isFranchise
                    ? _c("div", { staticClass: "summary_frais_amount" }, [
                        _c("p", { staticClass: "mg mg--t-2" }, [
                          _vm._v(
                            _vm._s(
                              _vm.replaceDots(_vm.damages.inmobilier.franchise)
                            ) + "€"
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ]),
              ]),
            ]),
            _vm.franchiseBelowContainerText
              ? _c("p", { staticClass: "mg mg--t-2" }, [
                  _vm._v(_vm._s(_vm.franchiseBelowContainerText)),
                ])
              : _vm._e(),
            _vm.isRen && !_vm.isRenCalendarFailure
              ? _c("p", { staticClass: "gray" }, [
                  _vm._v(_vm._s(_vm.$t("summary.immobilier.franchise.text"))),
                ])
              : _vm._e(),
            (_vm.damages && !_vm.isOnlyImmobilier) || _vm.getE2EFlow === "gag"
              ? _c("div", { staticClass: "summary_total mg mg--t-4" }, [
                  _c("p", { staticClass: "bold" }, [
                    _vm._v(_vm._s(_vm.$t("summary.frais.gag.total"))),
                  ]),
                  _vm.getE2EFlow === "gag" && _vm.isInmobilier
                    ? _c("p", { staticClass: "bold" }, [
                        _vm._v(
                          _vm._s(
                            _vm.replaceDots(_vm.damages.total_compensation)
                          ) + "€"
                        ),
                      ])
                    : _vm._e(),
                  _vm.getFlowState === "GAG_RESUME" && !_vm.isInmobilier
                    ? _c("p", { staticClass: "bold" }, [
                        _vm._v(
                          _vm._s(
                            _vm.replaceDots(
                              _vm.damages.mobilier.total_compensation_frais
                            )
                          ) + "€"
                        ),
                      ])
                    : _vm._e(),
                  (!_vm.isMobilier && _vm.getE2EFlow === "ren") ||
                  (!_vm.isMobilier && _vm.getE2EFlow === "billma")
                    ? _c("p", { staticClass: "bold" }, [
                        _vm._v(
                          _vm._s(
                            _vm.replaceDots(_vm.damages.frais.compensation_base)
                          ) + "€"
                        ),
                      ])
                    : _vm._e(),
                  (_vm.isMobilier && _vm.getE2EFlow === "ren") ||
                  (_vm.isMobilier && _vm.getE2EFlow === "billma")
                    ? _c("p", { staticClass: "bold" }, [
                        _vm._v(
                          _vm._s(
                            _vm.replaceDots(
                              _vm.damages.mobilier.total_compensation_frais
                            )
                          ) + "€"
                        ),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
          ]),
        ])
      : _vm._e(),
    _c("div", { staticClass: "container-btn-blue" }, [
      _c(
        "button",
        {
          staticClass: "summary_button btn mainBlue",
          on: { click: _vm.handlePrimaryButtonClick },
        },
        [_c("p", [_vm._v(_vm._s(_vm.$t("summary.confirm")))])]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }